import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">热搜榜单</h2>
          <span className="text-xs text-foreground-500 mt-1">实时热度排行</span>
        </div>

        <div className="max-w-[860px] mx-auto bg-background-100 rounded-lg border border-background-200/70 overflow-hidden">
          {rankingItems.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-3 md:gap-4 p-3 md:p-4 hover:bg-background-200/50 transition-colors cursor-pointer border-b border-background-200/60 last:border-b-0"
            >
              <div className={`w-8 h-8 md:w-9 md:h-9 rounded-md flex items-center justify-center flex-shrink-0 font-bold text-sm ${
                item.rank === 1
                  ? 'bg-primary-500 text-white'
                  : item.rank === 2
                  ? 'bg-accent-500 text-white'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-white'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-foreground-900 truncate">{item.title}</p>
                <p className="text-[11px] text-foreground-400 mt-0.5">{item.heat}</p>
              </div>

              <div className={`flex items-center gap-1 text-xs font-semibold flex-shrink-0 ${
                item.trend === 'up' ? 'text-primary-500' : 'text-secondary-500'
              }`}>
                {item.trend === 'up' ? (
                  <i className="ri-arrow-up-s-fill"></i>
                ) : (
                  <i className="ri-arrow-down-s-fill"></i>
                )}
                <span>{item.change}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}